import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import SectionHeading from "./SectionHeading";
import Reveal from "./Reveal";
import faq from "@/data/faq.json";

export default function Faq() {
    return (
        <section id="faq" data-testid="faq-section" className="bg-cream-card/60 py-20 lg:py-28">
            <div className="container-x max-w-3xl">
                <SectionHeading
                    align="center"
                    eyebrow="FAQ"
                    title={
                        <>
                            Perguntas <em className="text-coral">frequentes</em>
                        </>
                    }
                    description="Tudo o que você precisa saber sobre esta demonstração e como ela se conectaria a uma loja real."
                />

                <Reveal delay={0.15} className="mt-10">
                    <Accordion type="single" collapsible className="flex flex-col gap-3">
                        {faq.map((item, i) => (
                            <AccordionItem
                                key={item.id}
                                value={item.id}
                                data-testid={`faq-accordion-item-${i + 1}`}
                                className="rounded-2xl border border-sand bg-cream px-5 transition-colors data-[state=open]:border-coral/50"
                            >
                                <AccordionTrigger className="py-4 text-left text-sm font-bold text-forest hover:text-coral-dark hover:no-underline sm:text-base">
                                    {item.question}
                                </AccordionTrigger>
                                <AccordionContent className="pb-5 text-sm leading-relaxed text-graphite-muted">
                                    {item.answer}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </Reveal>
            </div>
        </section>
    );
}
